import {Component, Input} from '@angular/core';
import {UntypedFormGroup} from '@angular/forms';

@Component({
  selector: 'em-change-confirm-password',
  templateUrl: './change-confirm-password.component.html',
  styleUrls: ['./change-confirm-password.component.scss'],
  standalone: false,
})
export class ChangeConfirmPasswordComponent {
  @Input() form?: UntypedFormGroup;

  constructor() {}
}
